import React from 'react';
import {Button, Card, Image} from 'react-bootstrap';
import './VipProductCard.css'; // 自定义样式

const VipProductCard = ({item,toPay}) => {
    return (
        <Card className="product-card text-start mb-4" >
            <Card.Body>
                {item.config.badgeUrl && <span className="tag"><Image src={item.config.badgeUrl} height={30} /> </span>}
                <h5 className={'card-title'}>{item.title}{item.badge && <span className="discountTag">{item.badge}</span>}</h5>
                <span className="currentPrice">{item.price/100}</span>
                <span className="unit">{item.config.unit}</span>
                <span className="originalPrice">{item.originPrice/100}</span>
                <Button variant="primary" className="w-100 mb-4"
                        style={{
                            borderRadius: '30px',
                            height: '42px',
                            background: 'linear-gradient(-90deg, #963BC8, #02C8E3)',
                            border: 'none'
                        }}
                        onClick={() => {
                            toPay(item)
                        }}>购买</Button>
                <div className={'w-100'} style={{marginBottom: '10px',background: '#707070',height: '1px'}}>
                </div>

                <div
                    className={'description'}
                    dangerouslySetInnerHTML={{__html: item.config.descH5}}

                />
            </Card.Body>
        </Card>


    );
};

export default VipProductCard;
